import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'
import {
  CustomerDto,
  CustomerPreferencesDto,
  OrganizationTypeDto,
  OrganizationTypeDtoType,
} from '../../../interactors/gen/backendClient'
import { AssociationBureauMembers } from './AssociationBureauMembers'
import { AssociationDescription } from './AssociationDescription'
import { AssociationTheAssociationCard } from './AssociationTheAssociationCard'
import { AxiosError } from 'axios'
import { UseMutationResult } from 'react-query'
import { AssociationPermissions } from './AssociationPermissions'
import { useAccountsStore } from '../../../store/AccountsStore'
import { useMemberAccessPolicy } from '../../../utils/hooks/useMemberAccessPolicy'
import { StripeConnectButton } from '../../Adopters/StripeConnectButton'

interface AssociationProps {
  association: CustomerDto
  editAssociationMutation: UseMutationResult<CustomerDto, Error | AxiosError<unknown, any>, CustomerDto, unknown>
}

export const AssociationMyAssociationTab: React.FC<AssociationProps> = ({ association, editAssociationMutation }) => {
  const accountsStore = useAccountsStore()
  const { policy } = useMemberAccessPolicy(
    accountsStore.connectedAccount?.customerId,
    Boolean(accountsStore.connectedAccount)
  )

  //Global submit function used by all the association form components (not the owner form)
  const onSubmit = async (
    data: Partial<CustomerDto> & Partial<CustomerPreferencesDto> & Partial<OrganizationTypeDto>
  ) => {
    const organizationType = {
      type: data.type || association.organizationType?.type,
      otherField:
        data.type === OrganizationTypeDtoType.OtherOrganizations
          ? data?.otherField || association.organizationType?.otherField
          : undefined,
    }
    const preferences = {
      species: data.species || association.preferences.species,
    }
    console.log('On submit', data)

    const { species, ...restData } = data

    const newData = {
      ...association,
      ...restData,
      organizationType: organizationType,
      preferences: preferences,
      phoneNumber: ['+33', ''].includes(data.phoneNumber?.trim() || '') ? undefined : data.phoneNumber,
    }
    console.log('newData', newData)
    editAssociationMutation.mutate(newData)
  }

  if (!association) {
    return null
  }

  const shouldDisplayStripeRetentionCard = Boolean(
    accountsStore.isAdmin() &&
      policy?.trial.isEligibleForNewPolicy &&
      !policy?.stripeConnect.validatedAt &&
      policy?.trial.endsAt
  )

  return (
    <>
      {shouldDisplayStripeRetentionCard && (
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
              <Box>
                <Typography variant="h6" fontWeight={800}>
                  Licences illimitées: conservez-les via Stripe Connect
                </Typography>
                <Typography sx={{ mt: 0.5 }}>
                  {policy?.trial.isActive
                    ? `Il vous reste ${Math.max(
                        policy?.trial.daysRemaining || 0,
                        0
                      )} jour(s) pour valider Stripe Connect.`
                    : 'Votre période d’essai de 3 mois est terminée. Configurez Stripe Connect pour conserver cet accès.'}
                </Typography>
                {policy?.stripeConnect.currentlyUnavailable && (
                  <Typography sx={{ mt: 0.5, color: 'warning.main', fontWeight: 700 }}>
                    Votre compte Stripe Connect a déjà été validé mais semble actuellement indisponible.
                  </Typography>
                )}
              </Box>
              <StripeConnectButton
                variant="contained"
                color="primary"
                fullWidth={false}
                content="Configurer Stripe Connect"
                sx={{ textTransform: 'none', fontWeight: 700, whiteSpace: 'nowrap' }}
              />
            </Box>
          </CardContent>
        </Card>
      )}
      <AssociationDescription association={association!} onSubmit={onSubmit} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <AssociationPermissions association={association} onSubmit={onSubmit} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AssociationTheAssociationCard association={association} onSubmit={onSubmit} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <AssociationBureauMembers association={association!} onSubmit={onSubmit} />
        </Grid>
      </Grid>
    </>
  )
}
